import * as React from "react";
import { JSX } from "react/jsx-runtime";

const AdminIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={13} cy={13} r={13} fill="#4682B4" />
    <path
      d="M13 6L7 8.5V13C7 16.7 9.55 20.11 13 21C16.45 20.11 19 16.7 19 13V8.5L13 6ZM13 18.5C10.5 17.65 8.5 15.35 8.5 13V9.7L13 7.8L17.5 9.7V13C17.5 15.35 15.5 17.65 13 18.5Z"
      fill="white"
    />
  </svg>
);

export default AdminIcon;